<template>
    <div class="col-sm-6 col-md-6">
        <h2>{{ aboutsundair[getCurrentLocale] }}</h2>
        <p>
            <strong></strong> <span v-html="aboutsundairtext[getCurrentLocale]"></p>
        <br />
        <!-- <address class="contact-details">
            <span class="contact-phone">
                <i class="soap-icon-phone"></i> +49 30 53676791</span>
            <br />
            <a href="mailto:kundenservice@sundair.com" class="contact-email">kundenservice@sundair.com</a>
        </address>
        <ul class="social-icons clearfix">
            <li class="facebook">
                <a title="facebook" href="https://www.facebook.com/sundair/" data-toggle="tooltip" target="_new">
                    <i class="soap-icon-facebook"></i>
                </a>
            </li>
            <li class="linkedin">
                <a title="linkedin" href="https://www.linkedin.com/company/sundair" data-toggle="tooltip" target="_new">
                    <i class="soap-icon-linkedin"></i>
                </a>
            </li>
        </ul> -->
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import { mapMutations } from 'vuex';
    import { mapActions } from 'vuex';

    export default {

        /* >>> *************************************************************** / /* Data */
        data: function() {

            return {
                aboutsundair: {
                    en: '',
                    de: '',
                },
                aboutsundairtext: {
                    en: '',
                    de: '',
                },
                // currentLocale: 'de',
            };

        }, // eof data()
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Computed */
        computed: {

            ...mapGetters([
                'getCurrentLocale',
            ]),

        }, // eof computed{}
        /* <<< ****************************************************************/

    };
</script>

<style scoped>
    /* AB3B7A */
</style>


// WEBPACK FOOTER //
// src/components/shared/footer/ThirdRow.vue